const toCamelCase = (str) => {
  return str
    .replace(/[-_\s]+(.)?/g, (_, c) => (c ? c.toUpperCase() : ''))
    .replace(/^[A-Z]/, (c) => c.toLowerCase());
};

export default (sourceObject) =>
  typeof sourceObject === 'object' && sourceObject !== null
    ? Object.keys(sourceObject).reduce((accumulator, keyName) => {
        accumulator[toCamelCase(keyName)] = sourceObject[keyName];
        return accumulator;
      }, {})
    : sourceObject;
